module.exports = __webpack_public_path__ + "static/metal01-4cbc98b03393ed473d410a271db32f4c.png";